// @ts-nocheck
import React from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  Box,
  Typography,
  Grid,
  Button,
  CircularProgress,
  Checkbox,
  useMediaQuery,
  Modal,
} from "@mui/material";

import addContractorModalStyles from "../addContractorModal.module.css";
import { CustomInput } from "../../../../components/Custom/Input";
import {
  deleteContractorCertificateFilesAction,
  updateContractorCertificateFilesAction,
} from "../../../../store/actions/contractor";
import {
  ADD_CONTRACTOR_STEP5_SUCCESS,
  UPDATE_CONTRACTOR_CERTIFICATES_STEP5,
} from "../../../../store/constants/contractor";
import {
  ALERT_DIALOG,
  ALERT_DIALOG_CLOSE,
  ALERT_DIALOG_LOADING,
} from "../../../../store/constants/auth";
import {
  getCssVariableHandler,
  getRGBAFromRGBGivenAlphaHandler,
} from "../../../../utils/styles/getCssVariables";
import { NavLink } from "react-router-dom";
import {
  contractorCertificatesFormSchema,
} from "../ContractorCertificatesForms/contractorCertificatesFormSchema";
import { CustomChip } from "../../../../components/Custom/CustomIconButton";
import { Done } from "@mui/icons-material";
import GenericTransparentBtn from "../../../../components/Custom/GenericTransparentBtn";
import { CustomSwitch } from "../../../../components/Custom/Switch";
import ContractorCertificatesUploadModal from "../../../profile/components/ContractorCertificatesUploadModal";
import ReusableParentContainer from "../../../../components/Custom/ReusableParentContainer";
import UnderlineButton from "../../../../components/Custom/UnderlineButton";

const AddContractorFormStep2_1 = ({
  currentStep,
  setCurrentStep,
  closeModalHandler,
  FormDataBox,
  uiController,
  isEditing,
  isViewing,
  successCallbackStep1,
}) => {
  // Refs start...
  const isComponentMounted = React.useRef({
    resettingCity: false,
    updatingForm: false,
  });
  // Refs end...

  // Static data start...
  const dontRunOnMountInit = React.useMemo(() => {
    return {
      updatingForm: false,
      resettingCity: false,
    };
  }, []);

  const contractorCertificatesInit = React.useMemo(() => {
    return {
      OSHA_10: {
        checked: false,
        files: [],
      },
      OSHA_30: {
        checked: false,
        files: [],
      },
      CTS: {
        checked: false,
        files: [],
      },
      ETC: {
        checked: false,
        files: [],
      },
      Aerial_Scissor_Lifts: {
        checked: false,
        files: [],
      },
      Forklift: {
        checked: false,
        files: [],
      },
      Other: {
        checked: false,
        value: [],
      },
    };
  }, []);

  const contractorCertificatesUpdateSubmitInit = React.useMemo(() => {
    return {
      isLoading: false,
    };
  }, []);

  const contractorCertificateOtherInputInit = React.useMemo(() => {
    return {
      value: "",
      isOpen: false,
    };
  }, []);

  const contractorCertificateViewFullscreenInit = React.useMemo(() => {
    return {
      view: false,
      file: null,
    };
  }, []);
  // Static data end...

  // media query hooks start...
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  // media query hooks end...

  // Redux hooks start...
  const dispatch = useDispatch();
  // Selectors start...
  const auth = useSelector((store) => store.auth);
  const contractor = useSelector((store) => store.contractor);

  const contractorCertificates =
    contractor?.addContractor?.step5?.data?.certifications;
  // Selectors end...
  // Redux hooks end...

  // State variables start...
  const [
    contractorCertificatesInitialValues,
    setContractorCertificatesIntialValues,
  ] = React.useState(contractorCertificatesInit);
  const [
    contractorCertificatesUpdateSubmit,
    setContractorCertificatesUpdateSubmit,
  ] = React.useState(contractorCertificatesUpdateSubmitInit);
  const [
    contractorCertificatesChangedField,
    setContractorCertificatesChangedField,
  ] = React.useState(null);
  const [
    contractorCertificatesToggledField,
    setContractorCertificatesToggledField,
  ] = React.useState(null);
  const [openUploadCertificatesModal, setOpenUploadCertificatesModal] =
    React.useState(null);
  const [
    contractorCertificatesUploadOtherSubfield,
    setContractorCertificatesUploadOtherSubfield,
  ] = React.useState(null);
  const [contractorCertificateOtherInput, setContractorCertificateOtherInput] =
    React.useState(contractorCertificateOtherInputInit);
  const [
    contractorCertificatesSubmitLoading,
    setContractorCertificatesSubmitLoading,
  ] = React.useState(false);
  const [
    contractorCertificateViewFullscreen,
    setContractorCertificateViewFullscreen,
  ] = React.useState(contractorCertificateViewFullscreenInit);
  const [showCertificationsUI, setShowCertificationsUI] = React.useState(false);

	const [initialValues, setInitialValues] = React.useState({
		firstName: "",
		lastName: "",
		mobile: "",
		email: "",
		mailingAddress: "",
		city: "",
		state: "",
		zipCode: "",
		// einNumber: "",
		companyName: "",
	});

  // const [isValuesSyncedOnce, setIsValuesSyncedOnce] = React.useState(false);

  const [dontRunOnMount, setDontRunOnMount] =
    React.useState(dontRunOnMountInit);

  const [agreedToTandC, setAgreedToTandC] = React.useState(false);
  const [option, setOption] = React.useState(
    contractor?.addContractor?.step1?.previouslySubmittedForm
      ? contractor?.addContractor?.step1?.data?.companyName
        ? "own-company"
        : "work-individual"
      : "own-company",
  );
  // State variables end...

  // Form schema...
  const contractorCertificatesFormik = useFormik({
    validationSchema: contractorCertificatesFormSchema,
    initialValues: contractorCertificatesInitialValues,
    onSubmit: (values) => {
      const formData = new FormData();

      if (contractorCertificatesChangedField !== "Other") {
        formData.append("certificateName", contractorCertificatesToggledField);
        for (
          let i = 0;
          i <
          contractorCertificatesFormik.values?.[
            contractorCertificatesToggledField
          ]?.files?.length;
          i++
        ) {
          formData.append(
            `files`,
            contractorCertificatesFormik.values?.[
              contractorCertificatesToggledField
            ]?.files?.[i],
          );
        }
      } else {
        formData.append("certificateName", contractorCertificatesToggledField);
        formData.append(
          "otherCertificateName",
          contractorCertificateOtherInput?.value,
        );
        for (
          let i = 0;
          i <
          contractorCertificatesFormik.values?.["Other"]?.value?.[
            contractorCertificatesFormik.values?.["Other"]?.value?.length - 1
          ]?.files?.length;
          i++
        ) {
          formData.append(
            `files`,
            contractorCertificatesFormik.values?.["Other"]?.value?.[
              contractorCertificatesFormik.values?.["Other"]?.value?.length - 1
            ]?.files?.[i],
          );
        }
      }

      dispatch(
        updateContractorCertificateFilesAction({
          payload: formData,
          beforeCallback: () => {
            setContractorCertificatesSubmitLoading(true);
          },
          afterResponseCallback: () => {
            setContractorCertificatesSubmitLoading(false);
          },
          successCallback: ({ response }) => {
            dispatch({
              type: ADD_CONTRACTOR_STEP5_SUCCESS,
              payload: {
                data: response?.data?.data,
              },
            });
            setContractorCertificateViewFullscreen({
              ...contractorCertificateViewFullscreenInit,
            });
            setContractorCertificatesToggledField(null);
            setContractorCertificateOtherInput({
              ...contractorCertificateOtherInputInit,
            });
          },
          failureCallback: ({
            error
          }) => {
            dispatch({
              type: ALERT_DIALOG,
              payload: {
                open: true,
                title: "Error",
                message: error?.response?.data?.message || "Some error occured!"
              }
            })
          },
          params: {
            contractorId: contractor?.addContractor?.step1?.data?._id,
          },
        }),
      );
    },
  });
  // Form schema...

  // Handlers start...
  const handleMobileChange = (event) => {
    const input = event.target.value;
    const formattedInput = input
      .replace(/\D/g, "")
      .replace(/(\d{1,3})(\d{1,3})?(\d{1,4})?/, function (_, p1, p2, p3) {
        let formattedNumber = "";
        if (p1) {
          formattedNumber += p1;
        }
        if (p2) {
          formattedNumber += "-" + p2;
        }
        if (p3) {
          formattedNumber += "-" + p3;
        }
        return formattedNumber;
      });
    handleChange({
      target: {
        name: "mobile",
        value: formattedInput,
      },
    });
  };

  const deleteContractorCertificate = async ({
    toBeDeletedField,
    otherSubfield,
  }) => {
    if (toBeDeletedField) {
      dispatch({
        type: ALERT_DIALOG,
        payload: {
          open: true,
          avoidCloseOnOK: true,
          title: "Alert!",
          message: `This will delete all of your certificates for 
            ${otherSubfield ? otherSubfield?.otherCertificateName : toBeDeletedField}!`,
          closeLabel: "Cancel",
          onOk: () => {
            const payloadSubFields = {};

            if (otherSubfield) {
              payloadSubFields["certificateId"] = otherSubfield?._id;
            }

            dispatch(
              deleteContractorCertificateFilesAction({
                params: {
                  contractorId: contractor?.addContractor?.step1?.data?._id,
                },
                payload: {
                  certificateName: toBeDeletedField,
                  ...payloadSubFields,
                },
                beforeCallback: () => {
                  dispatch({
                    type: ALERT_DIALOG_LOADING,
                  });
                  setContractorCertificatesSubmitLoading(true);
                },
                afterResponseCallback: () => {
                  dispatch({
                    type: ALERT_DIALOG_CLOSE,
                  });
                  setContractorCertificatesSubmitLoading(false);
                },
                successCallback: ({ response }) => {
                  dispatch({
                    type: UPDATE_CONTRACTOR_CERTIFICATES_STEP5,
                    payload: response?.data?.data,
                  });
                  setContractorCertificateViewFullscreen({
                    ...contractorCertificateViewFullscreenInit,
                  });
                  setContractorCertificatesToggledField(null);
                  setContractorCertificateOtherInput({
                    ...contractorCertificateOtherInputInit,
                  });
                },
              }),
            );
          },
          onClose: () => {
            contractorCertificatesFormik.resetForm({
              values: contractorCertificatesInitialValues,
            });
          },
        },
      });
    }
  };

  const setupFileFullscreen = async (file) => {

    let fileUri;
    if (file?.url) {
      fileUri = file?.url;
    } else {
      fileUri = await fileToDataUri(file);
    }

    setContractorCertificateViewFullscreen(
      (contractorCertificateViewFullscreen) => {
        return {
          ...contractorCertificateViewFullscreen,
          view: true,
          file: fileUri,
        };
      },
    );
  };

  const fileToDataUri = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        resolve(event.target.result);
      };
      reader.readAsDataURL(file);
    });

  const getTotalUploadedFiles = (certificateType, otherCertIdx) => {
    let totalCertificates = 0;


    if (certificateType === "Other") {
      const otherCertificateIdx =
        otherCertIdx >= 0
          ? otherCertIdx
          : contractorCertificatesFormik.values?.[certificateType]?.value
              ?.length - 1;

      for (
        let i = 0;
        i <
        contractorCertificatesFormik.values?.[certificateType]?.value?.[
          otherCertificateIdx
        ]?.files?.length;
        i++
      ) {
        if (
          contractorCertificatesFormik.values?.[certificateType]?.value?.[
            otherCertificateIdx
          ]?.files?.[i]
        ) {
          totalCertificates += 1;
        }
      }
    } else {
      for (
        let i = 0;
        i <
        contractorCertificatesFormik.values?.[certificateType]?.files?.length;
        i++
      ) {
        if (
          contractorCertificatesFormik.values?.[certificateType]?.files?.[i]
        ) {
          totalCertificates += 1;
        }
      }
    }

    return totalCertificates;
  };

  const getTotalCertificateCount = () => {
    let totalCertificateCount = 0;

    for (let i = 0; i < Object.entries(contractorCertificatesFormik?.values)?.length; i++) {
      totalCertificateCount += getTotalUploadedFiles(Object.entries(contractorCertificatesFormik?.values)?.[i]?.[0]);
    }

    return totalCertificateCount;

  };

  // const getStateByName = (stateName) => {
  //     const country = Country.getCountryByCode(countryCode);
  //     return State.getStatesOfCountry(country.isoCode)
  //     ?.filter(state => {
  //         return (state?.name === stateName)
  //     })
  //     ?.map(state => {
  //         return {
  //             label: state?.name,
  //             value: state?.isoCode,
  //         }
  //     })?.[0];
  // }
  // Handlers end...

  // useEffects start...
  // React.useEffect(() => {
  // 	if (contractor?.addContractor?.step1?.form) {
  // 		setValues(contractor?.addContractor?.step1?.form);
  // 		setInitialValues(contractor?.addContractor?.step1?.form);
  // 	}
  // }, []);

  // React.useEffect(() => {
  //   if (dontRunOnMount?.resettingCity && changedFields?.state) {
  //     setFieldValue("city", "Select city");

  //     console.log(values, "cityUseEffect");
  //   }

  //   setDontRunOnMount((dontRunOnMount) => {
  //     return {
  //       ...dontRunOnMount,
  //       resettingCity: true,
  //     };
  //   });
  //   // isComponentMounted.current.resettingCity = true;
  // }, [values?.state, setFieldValue]);

  // React.useEffect(() => {
  // 	if (dontRunOnMount?.updatingForm) {
  // 		dispatch({
  // 			type: SET_CONTRACTOR_MULTIPLE_FIELDS,
  // 			payload: {
  // 				addContractor: {
  // 					...contractor?.addContractor,
  // 					step1: {
  // 						...contractor?.addContractor?.step1,
  // 						// form: contractor.addContractor?.step1?.form ? (
  // 						//     isValuesSyncedOnce ? values : contractor.addContractor?.step1?.form
  // 						// ) : values,
  // 						form: values,
  // 					},
  // 				},
  // 			},
  // 		});
  // 	}

  // 	setDontRunOnMount((dontRunOnMount) => {
  // 		return {
  // 			...dontRunOnMount,
  // 			updatingForm: true,
  // 		};
  // 	});
  // 	// setIsValuesSyncedOnce(true);
  // 	console.log(values, isComponentMounted, "formUseEffect");
  // 	// isComponentMounted.current.updatingForm = true;
  // }, [values, dispatch]);

  // reset form...
  // This reset is probably not required...
  // React.useEffect(() => {
  //   console.log(
  //     "resetFormAddCont",
  //     contractor?.addContractor?.reset?.count,
  //     typeof contractor?.addContractor?.reset?.count
  //   );
  //   if (typeof contractor?.addContractor?.reset?.count === "number") {
  //     resetForm();
  //   }
  // }, [contractor?.addContractor?.reset?.count]);

  React.useEffect(() => {
    if (contractorCertificates) {
      contractorCertificatesFormik.setValues((values) => {
        return {
          ...values,
          OSHA_10: {
            ...contractorCertificates?.[0]?.OSHA_10,
            checked: contractorCertificates?.[0]?.OSHA_10?.status,
          },
          OSHA_30: {
            ...contractorCertificates?.[0]?.OSHA_30,
            checked: contractorCertificates?.[0]?.OSHA_30?.status,
          },
          CTS: {
            ...contractorCertificates?.[0]?.CTS,
            checked: contractorCertificates?.[0]?.CTS?.status,
          },
          Forklift: {
            ...contractorCertificates?.[0]?.Forklift,
            checked: contractorCertificates?.[0]?.Forklift?.status,
          },
          ETC: {
            ...contractorCertificates?.[0]?.ETC,
            checked: contractorCertificates?.[0]?.ETC?.status,
          },
          Aerial_Scissor_Lifts: {
            ...contractorCertificates?.[0]?.Aerial_Scissor_Lifts,
            checked: contractorCertificates?.[0]?.Aerial_Scissor_Lifts?.status,
          },
          Other: {
            checked: Boolean(contractorCertificates?.[0]?.Other?.status),
            value:
              contractorCertificates?.[0]?.Other?.certificates?.map(
                (certificate) => {
                  return {
                    ...certificate,
                    checked: true,
                  };
                },
              ) || [],
          },
        };
      });

      setContractorCertificatesIntialValues(
        (contractorCertificatesInitialValues) => {
          return {
            ...contractorCertificatesInitialValues,
            OSHA_10: {
              ...contractorCertificates?.[0]?.OSHA_10,
              checked: contractorCertificates?.[0]?.OSHA_10?.status,
            },
            OSHA_30: {
              ...contractorCertificates?.[0]?.OSHA_30,
              checked: contractorCertificates?.[0]?.OSHA_30?.status,
            },
            CTS: {
              ...contractorCertificates?.[0]?.CTS,
              checked: contractorCertificates?.[0]?.CTS?.status,
            },
            Forklift: {
              ...contractorCertificates?.[0]?.Forklift,
              checked: contractorCertificates?.[0]?.Forklift?.status,
            },
            ETC: {
              ...contractorCertificates?.[0]?.ETC,
              checked: contractorCertificates?.[0]?.ETC?.status,
            },
            Aerial_Scissor_Lifts: {
              ...contractorCertificates?.[0]?.Aerial_Scissor_Lifts,
              checked:
                contractorCertificates?.[0]?.Aerial_Scissor_Lifts?.status,
            },
            Other: {
              checked: Boolean(contractorCertificates?.[0]?.Other?.status),
              value:
                contractorCertificates?.[0]?.Other?.certificates?.map(
                  (certificate) => {
                    return {
                      ...certificate,
                      checked: true,
                    };
                  },
                ) || [],
            },
          };
        },
      );
    }
  }, [contractorCertificates]);

  React.useEffect(() => {
    return () => {
      setDontRunOnMount({
        ...dontRunOnMountInit,
      });
    };
  }, []);
  // useEffects end...


  return (
    <>
      {/* <Box className={addContractorModalStyles["formDataBox"]}> */}
      <FormDataBox
        style={{
          height: "80%",
          overflowY: "auto",
          width: "100%",
          margin: "0 !important",
        }}
        className={"custom-scroll-design"}
      >
        <Box
          sx={{
            width: "100%",
            height: "fit-content",
            display: "flex",
            flexDirection: "column",
            margin: "auto 0",
            alignItems: "center",
            // flexWrap: "wrap",
            gap: "0.5rem",
            marginTop: "0.75rem",
          }}
        >
          <Typography
            sx={{
              fontSize: "1.5rem",
              textAlign: "center",
              marginBottom: "1rem",
            }}
          >
            Certifications
          </Typography>

          {showCertificationsUI || (getTotalCertificateCount() > 0) ? (
            <Box
              sx={{
                width: "95%",
                display: "flex",
                gap: "0.5rem",
                border: `1px solid ${getRGBAFromRGBGivenAlphaHandler({
                  rgb: getCssVariableHandler({
                    variableName: "--font-rgb",
                  }),
                  alpha: "0.5",
                })}`,
                borderRadius: "1rem",
              }}
            >
              <Box
                sx={{
                  width: "49%",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  className="settingBox"
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                    // marginBottom: "0 !important"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>OSHA 10</Typography>
                    {/* {contractorCertificatesUpdateSubmit?.isLoading && contractorCertificatesChangedField === "OSHA_10" ? (
                      <div className="status-loader"></div>
                    ) : ( */}
                    {!isViewing ? (
                      <CustomSwitch
                        checked={
                          contractorCertificatesFormik.values.OSHA_10.checked
                        }
                        name={"OSHA_10.checked"}
                        onChange={(e) => {
                          setContractorCertificatesChangedField(
                            "OSHA_10.checked",
                          );
                          setContractorCertificatesToggledField("OSHA_10");
                          setOpenUploadCertificatesModal(e?.target?.checked);
                          contractorCertificatesFormik.handleChange(
                            "OSHA_10.checked",
                          )(e);

                          if (!e?.target?.checked) {
                            deleteContractorCertificate({
                              toBeDeletedField: "OSHA_10",
                            });
                          }
                        }}
                      />
                    ) : null}
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.25rem",
                    }}
                  >
                    {contractorCertificatesFormik.values?.OSHA_10?.files?.map(
                      (file, idx) => {
                        return (
                          <React.Fragment key={idx}>
                            {file ? (
                              <CustomChip
                                // avatar={<Avatar>{option}</Avatar>}
                                sx={{
                                  height: "32px",
                                  minWidth: "50px",
                                  borderRadius: "28px !important",
                                }}
                                onClick={() => {
                                  setupFileFullscreen(file);
                                }}
                                key={idx}
                                label={`${file?.fileName?.substring?.(0, 7)}${file?.fileName?.length > 7 ? "..." : ""}`}
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      },
                    )}
                  </Box>
                </Box>
                <Box
                  className="settingBox"
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                    // marginBottom: "0 !important"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>CTS</Typography>
                    {/* {contractorCertificatesUpdateSubmit?.isLoading && contractorCertificatesChangedField === "CTS" ? (
                      <div className="status-loader"></div>
                    ) : ( */}
                    {!isViewing ? (
                      <CustomSwitch
                        checked={contractorCertificatesFormik.values.CTS.checked}
                        name={"CTS.checked"}
                        onChange={(e) => {
                          setContractorCertificatesChangedField("CTS.checked");
                          setContractorCertificatesToggledField("CTS");
                          setOpenUploadCertificatesModal(e?.target?.checked);
                          contractorCertificatesFormik.handleChange(
                            "CTS.checked",
                          )(e);

                          if (!e?.target?.checked) {
                            deleteContractorCertificate({
                              toBeDeletedField: "CTS",
                            });
                          }
                        }}
                      />
                    ) : null}
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.25rem",
                    }}
                  >
                    {contractorCertificatesFormik.values?.CTS?.files?.map(
                      (file, idx) => {
                        return (
                          <React.Fragment key={idx}>
                            {file ? (
                              <CustomChip
                                // avatar={<Avatar>{option}</Avatar>}
                                sx={{
                                  height: "32px",
                                  minWidth: "50px",
                                  borderRadius: "28px !important",
                                }}
                                onClick={() => {
                                  setupFileFullscreen(file);
                                }}
                                key={idx}
                                label={`${file?.fileName?.substring?.(0, 7)}${file?.fileName?.length > 7 ? "..." : ""}`}
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      },
                    )}
                  </Box>
                </Box>

                <Box
                  className="settingBox"
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                    // marginBottom: "0 !important"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>Aerial Scissor Lifts</Typography>
                    {/* {contractorCertificatesUpdateSubmit?.isLoading && contractorCertificatesChangedField === "Aerial_Scissor_Lifts" ? (
                      <div className="status-loader"></div>
                    ) : ( */}
                    {!isViewing ? (
                      <CustomSwitch
                        checked={
                          contractorCertificatesFormik.values.Aerial_Scissor_Lifts
                            .checked
                        }
                        name={"Aerial_Scissor_Lifts.checked"}
                        onChange={(e) => {
                          setContractorCertificatesChangedField(
                            "Aerial_Scissor_Lifts.checked",
                          );
                          setContractorCertificatesToggledField(
                            "Aerial_Scissor_Lifts",
                          );
                          setOpenUploadCertificatesModal(e?.target?.checked);
                          contractorCertificatesFormik.handleChange(
                            "Aerial_Scissor_Lifts.checked",
                          )(e);

                          if (!e?.target?.checked) {
                            deleteContractorCertificate({
                              toBeDeletedField: "Aerial_Scissor_Lifts",
                            });
                          }
                        }}
                      />
                    ) : null}
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.25rem",
                    }}
                  >
                    {contractorCertificatesFormik.values?.Aerial_Scissor_Lifts?.files?.map(
                      (file, idx) => {
                        return (
                          <React.Fragment key={idx}>
                            {file ? (
                              <CustomChip
                                // avatar={<Avatar>{option}</Avatar>}
                                sx={{
                                  height: "32px",
                                  minWidth: "50px",
                                  borderRadius: "28px !important",
                                }}
                                onClick={() => {
                                  setupFileFullscreen(file);
                                }}
                                key={idx}
                                label={`${file?.fileName?.substring?.(0, 7)}${file?.fileName?.length > 7 ? "..." : ""}`}
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      },
                    )}
                  </Box>
                </Box>

                <Box
                  sx={{
                    width: "100%",
                    border:
                      contractorCertificatesFormik.values?.Other?.value
                        ?.length === 0
                        ? "none"
                        : `1px solid ${getRGBAFromRGBGivenAlphaHandler({
                            rgb: getCssVariableHandler({
                              variableName: "--font-rgb",
                            }),
                            alpha: "0.45",
                          })}`,
                    borderRadius: "1rem",
                  }}
                >
                  <Box
                    className="settingBox"
                    sx={{
                      marginBottom: "0 !important",
                    }}
                  >
                    <Typography>Other</Typography>
                    {!isViewing ? (
                      <CustomSwitch
                        checked={
                          contractorCertificatesFormik.values.Other.checked
                        }
                        name={"Other.checked"}
                        onChange={(e) => {
                          setContractorCertificatesChangedField("Other");
                          contractorCertificatesFormik.handleChange(
                            "Other.checked",
                          )(e);

                          if (!e?.target?.checked) {
                            deleteContractorCertificate({
                              toBeDeletedField: "Other",
                            });
                          }
                        }}
                        // onChange={(e) => {
                        //   setContractorCertificates(contractorCertificates => {
                        //     return {
                        //       ...contractorCertificates,
                        //       Other: {
                        //         ...contractorCertificates?.Other,
                        //         checked: e?.target?.checked
                        //       }
                        //     }
                        //   });
                        // }}
                      />
                    ) : null}
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: "0.5rem",
                    }}
                  >
                    {contractorCertificatesFormik.values?.Other?.value ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexWrap: "wrap",
                          // gap: "0.5rem",
                          // padding: "1rem",
                        }}
                      >
                        {contractorCertificatesFormik.values?.Other?.value?.map?.(
                          (option, index) => {
                            return (
                              <React.Fragment key={index}>
                                <Box
                                  className="settingBox"
                                  sx={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: "0.5rem",
                                    marginBottom: "0 !important",
                                  }}
                                >
                                  <Box
                                    sx={{
                                      display: "flex",
                                      justifyContent: "space-between",
                                    }}
                                  >
                                    <Typography>
                                      {option?.otherCertificateName}
                                    </Typography>
                                    {/* {contractorCertificatesUpdateSubmit?.isLoading && contractorCertificatesChangedField === "OSHA_30" ? (
                                      <div className="status-loader"></div>
                                    ) : ( */}
                                    {!isViewing ? (
                                      <CustomSwitch
                                        checked={option.checked}
                                        name={`Other.value[${index}].checked`}
                                        onChange={(e) => {
                                          // setContractorCertificatesChangedField("OSHA_30.checked");
                                          // setContractorCertificatesToggledField("OSHA_30");
                                          // setOpenUploadCertificatesModal(e?.target?.checked);
                                          if (e.target?.checked) {
                                            contractorCertificatesFormik.handleChange(
                                              `Other.value[${index}].checked`,
                                            )(e);
                                          } else {
                                            deleteContractorCertificate({
                                              toBeDeletedField: "Other",
                                              otherSubfield: option,
                                            });
                                          }
                                        }}
                                      />
                                    ) : null}
                                  </Box>

                                  <Box
                                    sx={{
                                      display: "flex",
                                      flexWrap: "wrap",
                                      gap: "0.25rem",
                                    }}
                                  >
                                    {option?.files?.map((file, idx) => {
                                      return (
                                        <React.Fragment key={idx}>
                                          {file ? (
                                            <CustomChip
                                              // avatar={<Avatar>{option}</Avatar>}
                                              sx={{
                                                height: "32px",
                                                minWidth: "50px",
                                                borderRadius: "28px !important",
                                              }}
                                              key={idx}
                                              onClick={() => {
                                                setupFileFullscreen(file);
                                              }}
                                              label={`${(file?.fileName || file?.name)?.substring?.(0, 7)}${(file?.fileName || file?.name)?.length > 7 ? "..." : ""}`}
                                            />
                                          ) : null}
                                        </React.Fragment>
                                      );
                                    })}
                                  </Box>
                                </Box>
                              </React.Fragment>
                            );
                          },
                        )}
                      </Box>
                    ) : null}

                    {contractorCertificateOtherInput?.isOpen ? (
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          padding: "1rem",
                        }}
                      >
                        <CustomInput
                          sx={{
                            width: "100%",
                          }}
                          placeholder={"Please enter the value..."}
                          name={"contractorCertificateOtherInput"}
                          value={contractorCertificateOtherInput?.value}
                          // onBlur={contractorCertificatesFormik.handleBlur}
                          onChange={(e) => {
                            setContractorCertificateOtherInput(
                              (contractorCertificateOtherInput) => {
                                return {
                                  ...contractorCertificateOtherInput,
                                  value: e?.target?.value,
                                };
                              },
                            );
                          }}
                          endAdornment={
                            <GenericTransparentBtn
                              onClick={() => {
                                if (
                                  contractorCertificateOtherInput?.value?.trim()
                                    ?.length > 0
                                ) {
                                  if (
                                    contractorCertificateOtherInput?.value
                                      ?.trim()
                                      ?.split(",")
                                      ?.find((item) => !item.trim()) === ""
                                  ) {
                                    dispatch({
                                      type: ALERT_DIALOG,
                                      payload: {
                                        open: true,
                                        title: "Error!",
                                        message: "Please check the input!",
                                      },
                                    });
                                  } else {

                                    setContractorCertificatesToggledField(
                                      "Other",
                                    );
                                    setOpenUploadCertificatesModal(true);
                                    contractorCertificatesFormik.setValues(
                                      (values) => {
                                        return {
                                          ...values,
                                          Other: {
                                            ...values?.Other,
                                            value: [
                                              ...values?.Other?.value,
                                              {
                                                otherCertificateName:
                                                  contractorCertificateOtherInput?.value,
                                                checked: false,
                                                files: [],
                                              },
                                            ],
                                          },
                                        };
                                      },
                                    );
                                    // setContractorCertificatesSubmitLoading(
                                    //   true,
                                    // );
                                    // contractorCertificatesFormik.handleSubmit();
                                  }
                                } else {
                                  dispatch({
                                    type: ALERT_DIALOG,
                                    payload: {
                                      open: true,
                                      title: "Error!",
                                      message: "Please check the input!",
                                    },
                                  });
                                }
                              }}
                            >
                              {contractorCertificatesSubmitLoading ? (
                                <CircularProgress size={22} />
                              ) : (
                                <Done
                                  sx={{
                                    color: getCssVariableHandler({
                                      variableName: "--font-rgb",
                                    }),
                                  }}
                                />
                              )}
                            </GenericTransparentBtn>
                          }
                        />

                        {/* <GenericTransparentBtn
                          style={{
                            marginTop: "0.5rem",
                            alignSelf: "flex-end",
                            minWidth: "0",
                            padding: "0.25rem 0.8rem",
                            border: "1px solid white"
                          }}
                          onClick={() => {
                            setContractorCertificateOtherInput({...contractorCertificateOtherInputInit});
                          }}
                        >
                          Close
                        </GenericTransparentBtn> */}
                      </Box>
                    ) : null}

                    {!isViewing &&
                    contractorCertificatesFormik?.values?.Other?.checked &&
                    !contractorCertificateOtherInput?.isOpen ? (
                      <GenericTransparentBtn
                        style={{
                          alignSelf: "flex-start",
                        }}
                      >
                        <Typography
                          variant="span"
                          sx={{
                            fontSize: "14px",
                            color: getCssVariableHandler({
                              variableName: "--primary-pink-rgb",
                            }),
                            marginTop: "8px",
                            padding: "0 1rem",
                            display: "inline-block",
                            cursor: "pointer",
                          }}
                          onClick={() => {
                            setContractorCertificatesChangedField("Other");
                            setContractorCertificateOtherInput(
                              (contractorCertificateOtherInput) => {
                                return {
                                  ...contractorCertificateOtherInput,
                                  value: "",
                                  isOpen: true,
                                };
                              },
                            );
                            // contractorCertificatesFormik.setValues(values => {
                            //   return {
                            //     ...values,
                            //     Other: {
                            //       ...values?.Other,
                            //       checked: true
                            //     }
                            //   }
                            // })
                          }}
                        >
                          Add New Certificate
                        </Typography>
                      </GenericTransparentBtn>
                    ) : null}
                  </Box>
                </Box>
              </Box>

              <Box
                sx={{
                  width: "1px",
                  backgroundColor: getCssVariableHandler({
                    variableName: "--font-rgb",
                  }),
                }}
              />

              <Box
                sx={{
                  width: "49%",
                  alignSelf: "flex-start",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <Box
                  className="settingBox"
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                    // marginBottom: "0 !important"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>OSHA 30</Typography>
                    {/* {contractorCertificatesUpdateSubmit?.isLoading && contractorCertificatesChangedField === "OSHA_30" ? (
                      <div className="status-loader"></div>
                    ) : ( */}
                    {!isViewing ? (
                      <CustomSwitch
                        checked={
                          contractorCertificatesFormik.values.OSHA_30.checked
                        }
                        name={"OSHA_30.checked"}
                        onChange={(e) => {
                          setContractorCertificatesChangedField(
                            "OSHA_30.checked",
                          );
                          setContractorCertificatesToggledField("OSHA_30");
                          setOpenUploadCertificatesModal(e?.target?.checked);
                          contractorCertificatesFormik.handleChange(
                            "OSHA_30.checked",
                          )(e);

                          if (!e?.target?.checked) {
                            deleteContractorCertificate({
                              toBeDeletedField: "OSHA_30",
                            });
                          }
                        }}
                      />
                    ) : null}
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.25rem",
                    }}
                  >
                    {contractorCertificatesFormik.values?.OSHA_30?.files?.map(
                      (file, idx) => {
                        return (
                          <React.Fragment key={idx}>
                            {file ? (
                              <CustomChip
                                // avatar={<Avatar>{option}</Avatar>}
                                sx={{
                                  height: "32px",
                                  minWidth: "50px",
                                  borderRadius: "28px !important",
                                }}
                                onClick={() => {
                                  setupFileFullscreen(file);
                                }}
                                key={idx}
                                label={`${file?.fileName?.substring?.(0, 7)}${file?.fileName?.length > 7 ? "..." : ""}`}
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      },
                    )}
                  </Box>
                </Box>
                <Box
                  className="settingBox"
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                    // marginBottom: "0 !important"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>ETC</Typography>
                    {/* {contractorCertificatesUpdateSubmit?.isLoading && contractorCertificatesChangedField === "ETC" ? (
                      <div className="status-loader"></div>
                    ) : ( */}
                    {!isViewing ? (
                      <CustomSwitch
                        checked={contractorCertificatesFormik.values.ETC.checked}
                        name={"ETC.checked"}
                        onChange={(e) => {
                          setContractorCertificatesChangedField("ETC.checked");
                          setContractorCertificatesToggledField("ETC");
                          setOpenUploadCertificatesModal(e?.target?.checked);
                          contractorCertificatesFormik.handleChange(
                            "ETC.checked",
                          )(e);

                          if (!e?.target?.checked) {
                            deleteContractorCertificate({
                              toBeDeletedField: "ETC",
                            });
                          }
                        }}
                      />
                    ) : null}
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      gap: "0.25rem",
                    }}
                  >
                    {contractorCertificatesFormik.values?.ETC?.files?.map(
                      (file, idx) => {
                        return (
                          <React.Fragment key={idx}>
                            {file ? (
                              <CustomChip
                                // avatar={<Avatar>{option}</Avatar>}
                                sx={{
                                  height: "32px",
                                  minWidth: "50px",
                                  borderRadius: "28px !important",
                                }}
                                onClick={() => {
                                  setupFileFullscreen(file);
                                }}
                                key={idx}
                                label={`${file?.fileName?.substring?.(0, 7)}${file?.fileName?.length > 7 ? "..." : ""}`}
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      },
                    )}
                  </Box>
                </Box>
                <Box
                  className="settingBox"
                  sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: "0.5rem",
                    // marginBottom: "0 !important"
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography>Forklift</Typography>
                    {/* {contractorCertificatesUpdateSubmit?.isLoading && contractorCertificatesChangedField === "Forklift" ? (
                      <div className="status-loader"></div>
                    ) : ( */}
                    {!isViewing ? (
                      <CustomSwitch
                        checked={
                          contractorCertificatesFormik.values.Forklift.checked
                        }
                        name={"Forklift.checked"}
                        onChange={(e) => {
                          setContractorCertificatesChangedField(
                            "Forklift.checked",
                          );
                          setContractorCertificatesToggledField("Forklift");
                          setOpenUploadCertificatesModal(e?.target?.checked);
                          contractorCertificatesFormik.handleChange(
                            "Forklift.checked",
                          )(e);

                          if (!e?.target?.checked) {
                            deleteContractorCertificate({
                              toBeDeletedField: "Forklift",
                            });
                          }
                        }}
                      />
                    ) : null}
                  </Box>

                  <Box
                    sx={{
                      display: "flex",
                      flexWrap: "wrap",
                      gap: "0.25rem",
                    }}
                  >
                    {contractorCertificatesFormik.values?.Forklift?.files?.map(
                      (file, idx) => {
                        return (
                          <React.Fragment key={idx}>
                            {file ? (
                              <CustomChip
                                // avatar={<Avatar>{option}</Avatar>}
                                sx={{
                                  height: "32px",
                                  minWidth: "50px",
                                  borderRadius: "28px !important",
                                }}
                                onClick={() => {
                                  setupFileFullscreen(file);
                                }}
                                key={idx}
                                label={`${file?.fileName?.substring?.(0, 7)}${file?.fileName?.length > 7 ? "..." : ""}`}
                              />
                            ) : null}
                          </React.Fragment>
                        );
                      },
                    )}
                  </Box>
                </Box>
              </Box>
            </Box>
          ) : (
            !isViewing ? (
              <>
                <Typography>
                  No certificates found
                </Typography>
                <UnderlineButton
                  title={"Add certifications"}
                  onClick={() => {
                    setShowCertificationsUI(true);
                  }}
                  // className="btn-pink"
                />
              </>
            ) : (
              <Typography>
                No certificates found
              </Typography>
            )
          )}
          
        </Box>
        {!(isViewing || isEditing) &&
        !contractor?.addContractor?.step1?.previouslySubmittedForm ? (
          <Grid item xs={12}>
            <Box className={addContractorModalStyles["form-box"]}>
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  gap: "0.25rem",
                }}
              >
                <Checkbox
                  onChange={(e) => {
                    // setTwoFactorAuthentication(e.target.checked);
                    setAgreedToTandC(e.target.checked);
                  }}
                  sx={{
                    color: getCssVariableHandler({
                      variableName: "--font-rgb",
                    }),
                    padding: "0",
                  }}
                  checked={agreedToTandC}
                />

                <Typography>
                  I accept the{" "}
                  <NavLink to={"/terms-and-conditions"} target="_blank">
                    Terms and Conditions
                  </NavLink>{" "}
                  and{" "}
                  <NavLink to={"/privacy-policy"} target="_blank">
                    Privacy policy
                  </NavLink>
                </Typography>
              </Box>
              {/* <Box className={individualFormStyles.profile}>
              <Box
                sx={{
                  "& img": {
                    borderRadius: "50%",
                  },
                }}
              >
                {values?.files ? (
                  <img
                    src={
                      typeof values?.files === "string" &&
                      values?.files?.includes?.("http")
                        ? values?.files
                        : URL.createObjectURL(values?.files)
                    }
                    alt={""}
                    style={{
                      objectFit: "cover",
                    }}
                  />
                ) : (
                  <Box
                    sx={{
                      padding: "2rem 3rem",
                      background: getCssVariableHandler({
                        variableName: "--dark-blue-1-rgb",
                      }),
                      border: `1px solid ${getCssVariableHandler({
                        variableName: "--font-rgb",
                      })}`,
                      borderRadius: "0.5rem",
                    }}
                  >
                    <ImageIcon
                      style={{
                        color: getCssVariableHandler({
                          variableName: "--font-rgb",
                        }),
                      }}
                    />
                  </Box>
                )}
              </Box>
              <Box>
                <input
                  type="file"
                  accept="image/*"
                  className={individualFormStyles.fileInput}
                  onChange={(e) => {
                    if (e.target.files.length > 0) {
                      setFieldValue("files", e.target.files[0]);
                    }
                  }}
                  ref={imageRef}
                />
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "0.25rem",
                  }}
                >
                  <Typography
                    variant="span"
                    sx={{
                      color: getCssVariableHandler({
                        variableName: "--font-rgb",
                      }),
                    }}
                  >
                    Upload Photo
                  </Typography>
                  <InputLabel htmlFor="upload-profile-picture">
                    <Button
                      onClick={imageClickHandler}
                      sx={{
                        minWidth: "0",
                        padding: "0.5rem 2rem",
                      }}
                    >
                      UPLOAD
                    </Button>
                  </InputLabel>
                </Box>
              </Box>
            </Box> */}
            </Box>
          </Grid>
        ) : null}
        {/* </Grid> */}
        {/* </Box> */}
      </FormDataBox>

      {uiController?.showBottomBtnBox ? (
        <Box
          className="bottom-btn-box"
          sx={{
            width: "100%",
            marginTop: "2rem",
            alignSelf: "flex-end",
          }}
        >
          <Button
            className="btn-black"
            sx={{
              width: "50%",
              height: "4.25rem",
              textTransform: "none !important",
            }}
            onClick={(e) => {
              setCurrentStep((currentStep) => {
                return currentStep - 1;
              });
            }}
            // onClick={onClose}
          >
            <Typography className="btn-text">Back</Typography>
          </Button>

          <Button
            className="btn-pink"
            sx={{
              width: "50%",
              height: "4.25rem",
              textTransform: "none !important",
              "&:disabled": {
                background: "#d85ad8 !important",
              },
            }}
            onClick={(e) => {
              setCurrentStep((currentStep) => {
                return currentStep + 1;
              });
            }}
            // onClick={onClose}
          >
            {contractor?.addContractor?.step1?.submitFormRequestLoading ? (
              <CircularProgress size={22} />
            ) : (
              <Typography className="btn-text">
                {isViewing ? "Continue" : "Save and Continue"}
              </Typography>
            )}
          </Button>
        </Box>
      ) : null}

      {openUploadCertificatesModal &&
      contractorCertificatesToggledField &&
      contractorCertificatesFormik?.values?.[contractorCertificatesToggledField]
        ?.checked &&
      !contractorCertificateViewFullscreen?.view ? (
        <ContractorCertificatesUploadModal
          contractorCertificatesFormik={contractorCertificatesFormik}
          contractorCertificatesToggledField={
            contractorCertificatesToggledField
          }
          fileToDataUri={fileToDataUri}
          setContractorCertificateViewFullscreen={
            setContractorCertificateViewFullscreen
          }
          setOpenUploadCertificatesModal={setOpenUploadCertificatesModal}
          setContractorCertificateOtherInput={
            setContractorCertificateOtherInput
          }
          getTotalUploadedFiles={getTotalUploadedFiles}
          setContractorCertificatesChangedField={
            setContractorCertificatesChangedField
          }
          setContractorCertificatesToggledField={
            setContractorCertificatesToggledField
          }
          contractorCertificatesSubmitLoading={
            contractorCertificatesSubmitLoading
          }
          contractorCertificateOtherInputInit={
            contractorCertificateOtherInputInit
          }
          contractorCertificatesInitialValues={
            contractorCertificatesInitialValues
          }
        />
      ) : null}

      {contractorCertificateViewFullscreen?.view ? (
        <Modal
          open={contractorCertificateViewFullscreen?.view}
          onClose={() => {
            setContractorCertificateViewFullscreen({
              view: false,
              file: null,
            });
          }}
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Box
            sx={{
              maxWidth: "1000px",
              width: "80vw",
              height: "85vh",
            }}
          >
            <ReusableParentContainer
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                background: getCssVariableHandler({
                  variableName: "--bg-theme-rgb",
                }),
                width: "100%",
                height: "100%",
                padding: "1rem 2rem",
              }}
            >
              {/* <img
								src={URL.createObjectURL(contractorCertificateViewFullscreen?.file)}
								alt=""
								style={{
									borderRadius: "10px",
									width: "100%",
									height: "100%",
									objectFit: "cover",
									verticalAlign: "middle",
								}}
							/> */}

              {/* <Document file={contractorCertificateViewFullscreen?.file}>
								<Page pageNumber={1} />
							</Document> */}

              <Box
                sx={{
                  width: "100%",
                  height: "100%",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <iframe
                  src={contractorCertificateViewFullscreen?.file}
                  width={"100%"}
                  height={"100%"}
                />
              </Box>

              {/* <ReactPDF
								
								// file={{
								//   data: contractorCertificateViewFullscreen?.file
								// }}
							/> */}
            </ReusableParentContainer>
          </Box>
        </Modal>
      ) : null}
    </>
  );
};

AddContractorFormStep2_1.propTypes = {
  currentStep: PropTypes.number,
  setCurrentStep: PropTypes.func,
  closeModalHandler: PropTypes.func,
  uiController: PropTypes.object,
  isEditing: PropTypes.bool.isRequired,
  isViewing: PropTypes.bool.isRequired,
  successCallbackStep1: PropTypes.func,
};

export default AddContractorFormStep2_1;